import { apiCallCenter } from '@/plugins/axios'

export default {

  getDepartment(){
    return apiCallCenter().get('/relatorios/disponibilidade/departamento/lazy')
  },

  getAgents() {
    return apiCallCenter().get('/relatorios/disponibilidade/operadores/lazy')
  },
}
